import { gql } from '@apollo/client'
import { Caption } from '@farol-ds/react'

import { ModalLock } from '../modal-lock'
import {
  ThirdPartyBackgroundCheckLock_OfferLockDataFragment,
  ThirdPartyBackgroundCheckLock_ViewerFragment,
} from './__generated__/third-party-background-check-lock.graphql'
import { ThirdPartyBackGroundCheckContent } from './third-party-background-check-content'
import styles from './third-party-background-check-lock.module.scss'

const Footer = ({ text }: { text: string }) => {
  return (
    <Caption className={styles.thirdPartyBackgroundCheckLockFooter}>
      <p dangerouslySetInnerHTML={{ __html: text }} />
    </Caption>
  )
}

export interface ThirdPartyBackgroundCheckLockProps {
  offerLockData: ThirdPartyBackgroundCheckLock_OfferLockDataFragment
  viewer: ThirdPartyBackgroundCheckLock_ViewerFragment
}

export function ThirdPartyBackgroundCheckLock({
  offerLockData,
  viewer,
}: ThirdPartyBackgroundCheckLockProps) {
  return (
    <ModalLock
      offerLockBody={offerLockData.body}
      footerContent={<Footer text={offerLockData.footer.text} />}
    >
      <ThirdPartyBackGroundCheckContent offerLockData={offerLockData} viewer={viewer} />
    </ModalLock>
  )
}

ThirdPartyBackgroundCheckLock.fragments = {
  offerLockData: gql`
    fragment ThirdPartyBackgroundCheckLock_offerLockData on OfferLockData {
      ...ThirdPartyBackGroundCheckContent_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
      footer {
        text
      }
    }
    ${ThirdPartyBackGroundCheckContent.fragments.offerLockData}
    ${ModalLock.fragments.offerLockBody}
  `,
  viewer: gql`
    fragment ThirdPartyBackgroundCheckLock_viewer on Profile {
      ...ThirdPartyBackGroundCheckContent_viewer
    }
    ${ThirdPartyBackGroundCheckContent.fragments.viewer}
  `,
}
